import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs/operators";
import { IThemeOptions } from "../../models";
import { PictureInPictureStore } from "../../services/store/picture-in-picture.store";
import { ThemeService } from "../../services/theme.service";

/** an admin set the font color, either in appearance settings or in the custom css */
export function hasCustomFontColor(theme: IThemeOptions): boolean {
  return (
    !!theme?.color || /--av-font-color\s*:/.test(theme?.customThemeCSS ?? "")
  );
}

/** shown in the call tab while the call is in the picture-in-picture window */
@Component({
  selector: "app-pip-placeholder",
  templateUrl: "./pip-placeholder.component.html",
  styleUrls: ["./pip-placeholder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PipPlaceholderComponent {
  private pipStore = inject(PictureInPictureStore);
  private themeService = inject(ThemeService);

  readonly isCustomFontColor = toSignal(
    this.themeService.themeChanged$().pipe(map(hasCustomFontColor)),
    { initialValue: false }
  );

  bringBack() {
    this.pipStore.close();
  }
}
